export default {
  FETCH_SUBURBS_REQUEST: 'FETCH_SUBURBS_REQUEST',
  FETCH_SUBURBS_SUCCESS: 'FETCH_SUBURBS_SUCCESS',
  FETCH_SUBURBS_FAILURE: 'FETCH_SUBURBS_FAILURE',
  UPDATE_SUBURBS_QUERY: 'UPDATE_SUBURBS_QUERY'
}
